module.exports = __webpack_public_path__ + "media/images/application/icons/trash-839c7a852b2ac15dac84c89e10e14b69.svg";